import { useEffect, useState } from 'react';
import {
  ApplicationDocument,
  ApplicationDocumentStatus,
} from '../../../../../hoc/new-application/types';
import {
  useChangeCOFApplicationDocumentStatusMutation,
  useChangeCorporateApplicationDocumentStatusMutation,
  useChangeIndividualApplicationDocumentStatusMutation,
  useLazyGetCofApplicationDocumentFileQuery,
  useLazyGetCorporateApplicationDocumentFileQuery,
  useLazyGetIndividualApplicationDocumentFileQuery,
} from '../../../../../hoc/new-application/store/services';

const useDocumentItem = ({
  isCorporate,
  applicationId,
  documentItem,
  isCof,
}: {
  isCorporate?: boolean;
  applicationId?: string;
  documentItem: ApplicationDocument;
  isCof?: boolean;
}) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<
    ApplicationDocumentStatus | undefined
  >();

  const [
    getCorporateApplicationDocumentFile,
    { isLoading, isSuccess, isError },
  ] = useLazyGetCorporateApplicationDocumentFileQuery();
  const [
    changeCorporateDocumentStatus,
    { isLoading: statusChangeInProgress, isSuccess: statusChangeIsSuccess },
  ] = useChangeCorporateApplicationDocumentStatusMutation();

  const [
    getIndividualApplicationDocumentFile,
    {
      isLoading: individualIsLoading,
      isSuccess: individualIsSuccess,
      isError: individualIsError,
    },
  ] = useLazyGetIndividualApplicationDocumentFileQuery();
  const [
    changeIndividualDocumentStatus,
    {
      isLoading: individualStatusChangeInProgress,
      isSuccess: individualStatusChangeIsSuccess,
    },
  ] = useChangeIndividualApplicationDocumentStatusMutation();

  const [
    getCofApplicationDocumentFile,
    { isLoading: cofIsLoading, isSuccess: cofIsSuccess, isError: cofIsError },
  ] = useLazyGetCofApplicationDocumentFileQuery();
  const [
    changeCofDocumentStatus,
    {
      isLoading: cofStatusChangeInProgress,
      isSuccess: cofStatusChangeIsSuccess,
    },
  ] = useChangeCOFApplicationDocumentStatusMutation();

  const getFile = async () => {
    let response;

    if (isCorporate) {
      response = await getCorporateApplicationDocumentFile({
        id: applicationId as string,
        documentId: documentItem.id,
      });
    } else if (isCof) {
      response = await getCofApplicationDocumentFile({
        id: applicationId as string,
        documentId: documentItem.id,
      });
    } else {
      response = await getIndividualApplicationDocumentFile({
        id: applicationId as string,
        documentId: documentItem.id,
      });
    }

    if (response?.data) {
      const hiddenElement = document.createElement('a');
      const url = window.URL || window.webkitURL;

      // @ts-ignore
      const blob = url.createObjectURL(response.data);
      hiddenElement.href = blob;
      hiddenElement.target = '_blank';
      hiddenElement.download = documentItem.name;
      hiddenElement.click();
    }
  };

  useEffect(() => {
    if (
      isSuccess ||
      individualIsSuccess ||
      cofIsSuccess ||
      isError ||
      individualIsError ||
      cofIsError ||
      statusChangeIsSuccess ||
      individualStatusChangeIsSuccess ||
      cofStatusChangeIsSuccess
    ) {
      setMenuVisible(false);

      if (statusChangeIsSuccess) {
        setSelectedStatus(undefined);
      }
    }
  }, [
    isSuccess,
    isError,
    statusChangeIsSuccess,
    individualIsSuccess,
    cofIsSuccess,
    individualIsError,
    cofIsError,
    individualStatusChangeIsSuccess,
    cofStatusChangeIsSuccess,
  ]);

  return {
    setMenuVisible,
    menuVisible,
    setSelectedStatus,
    changeCorporateDocumentStatus,
    changeCofDocumentStatus,
    changeIndividualDocumentStatus,
    statusChangeInProgress:
      statusChangeInProgress ||
      individualStatusChangeInProgress ||
      cofStatusChangeInProgress,
    selectedStatus,
    isLoading: isLoading || individualIsLoading || cofIsLoading,
    getFile,
  };
};

export default useDocumentItem;
